// Remplacez ces URL par les photos originales de l'institut.
export const photos = {
  reception: 'https://cdn.magicpatterns.com/patterns/generated-images/95e6a4b5-e846-4c7b-b02d-c2f2e96eab3d.jpg',
  hammam: 'https://cdn.magicpatterns.com/patterns/generated-images/ebb44847-c1a3-4e4a-aec2-5203fc96c5d2.jpg',
  cabine: 'https://cdn.magicpatterns.com/patterns/generated-images/4b027dcb-54ab-4eb5-b161-411b703a7b97.jpg',
  facial: 'https://cdn.magicpatterns.com/patterns/generated-images/1775f12d-194d-4755-8ec9-526017e556fe.jpg',
  repos: 'https://cdn.magicpatterns.com/patterns/generated-images/020f482d-68d0-478f-83a8-1b61dcb77c18.jpg',
}

export const bookingUrl = 'https://commeuncharme.fr/prestations'

export const navLinks = [
  { label: 'Nos soins', href: '#soins' },
  { label: 'Forfaits', href: 'https://commeuncharme.fr/forfaits' },
  { label: 'Produits', href: 'https://commeuncharme.fr/produits' },
  { label: 'Carte cadeau', href: '#carte-cadeau' },
  { label: "L'institut", href: '#institut' },
  { label: 'Contact', href: '#contact' },
]

export const spaceFacts = [
  { value: '150 m²', label: 'répartis sur deux étages' },
  { value: '4', label: 'cabines de soins, plus une cabine gommages & enveloppements' },
  { value: '6', label: 'personnes accueillies dans notre hammam' },
  { value: '1', label: 'espace repos avec infusions de herboristeries françaises' },
]

export type Treatment = {
  name: string
  subtitle: string
  description: string
  duration?: string
  price?: string
}

export type TreatmentCategory = {
  id: string
  label: string
  intro: string
  items: Treatment[]
}

export const treatmentCategories: TreatmentCategory[] = [
  {
    id: 'visage',
    label: 'Soins visage',
    intro: 'Technologie Hydrafacial Vortex Fusion : nettoyage profond, hydratation intense, résultats visibles dès la première séance.',
    items: [
      {
        name: 'Hydrafacial Glow',
        subtitle: 'Peeling doux & éclat',
        description: 'Peeling enzymatique et hydratation intense pour un teint lumineux, idéal avant un événement.',
        duration: '30 min',
        price: '80 €',
      },
      {
        name: 'Hydrafacial Signature avec Booster',
        subtitle: 'Soin ciblé & personnalisé',
        description: 'Sérum booster choisi selon votre peau, cavitation, radiofréquence et masque cryothérapie.',
        duration: '1 h',
        price: '170 €',
      },
      {
        name: 'Hydrafacial Platinum',
        subtitle: 'Détoxifiant & anti-âge',
        description: 'Ionisation, musculation faciale et drainage lymphatique pour un effet liftant immédiat.',
        duration: '1 h 30',
        price: '250 €',
      },
    ],
  },
  {
    id: 'massages',
    label: 'Massages',
    intro: 'Nos massages signature, inspirés des traditions du monde entier, pour détendre le corps et apaiser l’esprit.',
    items: [
      { name: 'Massage californien', subtitle: 'Enveloppant & relaxant', description: 'Des gestes longs et fluides pour relâcher les tensions en profondeur.' },
      { name: 'Massage ayurvédique', subtitle: 'Tradition indienne', description: 'Un rituel rythmé aux huiles chaudes qui rééquilibre et revitalise.' },
      { name: 'Massage aux pierres chaudes', subtitle: 'Chaleur apaisante', description: 'La chaleur des pierres dénoue les muscles et invite au lâcher-prise.' },
    ],
  },
  {
    id: 'hammam',
    label: 'Hammam & corps',
    intro: 'L’art du hammam, complété par nos gommages et enveloppements dans une cabine dédiée.',
    items: [
      { name: 'Hammam', subtitle: 'Jusqu’à 6 personnes', description: 'Un moment de chaleur et de purification, seul ou entre proches.' },
      { name: 'Gommages & enveloppements', subtitle: 'Cabine dédiée', description: 'Une peau lissée, nourrie et adoucie de la tête aux pieds.' },
      { name: 'Soins minceur LPG', subtitle: 'Programmes sur-mesure', description: 'Des techniques de pointe pour remodeler et raffermir la silhouette.' },
    ],
  },
  {
    id: 'beaute',
    label: 'Beauté',
    intro: 'Les essentiels de beauté réalisés avec le même soin du détail.',
    items: [
      { name: 'Épilation', subtitle: 'Cire ou orientale', description: 'Des gestes précis et une hygiène irréprochable.' },
      { name: 'Manucure & beauté des pieds', subtitle: 'Mains et pieds', description: 'Soin, mise en beauté et pose de vernis.' },
      { name: 'Maquillage & sourcils', subtitle: 'Mise en beauté', description: 'Maquillage et teinture des sourcils pour sublimer votre regard.' },
    ],
  },
]

export const rating = { score: '4,4', count: 65 }

export const reviews = [
  {
    quote: 'Super massage régénérant & relaxant, le personnel est aux petits soins. Je recommande vivement !',
    author: 'Lohanna Zeitoun',
    date: 'Avril 2026',
  },
  {
    quote: 'Une oasis de détente et d’élégance. Ma praticienne Kathy maîtrise les techniques de pointe, tant en massages qu’en programmes LPG. La clientèle est choyée.',
    author: 'Cliente de l’institut',
    date: 'Avis vérifié',
  },
  {
    quote: 'J’ai commandé en ligne plusieurs fois et la livraison a toujours été rapide et soigneuse. De bonnes marques. Je recommande à 100 %.',
    author: 'Claude Zerbib',
    date: 'Mars 2026',
  },
  {
    quote: 'Masque Guinot longue vie efficace. Beaucoup d’échantillons ont été ajoutés à mon colis.',
    author: 'Valérie Sanchez',
    date: 'Juillet 2026',
  },
]

export const contact = {
  address: '61 rue de la Tour',
  city: '75116 Paris',
  mapsUrl: 'https://www.google.com/maps/search/?api=1&query=61+rue+de+la+Tour+75116+Paris',
  instagram: 'https://www.instagram.com/institutcommeuncharme',
}
